import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { animateScroll as scroll } from 'react-scroll';
import {
	MDBNavbar as Navbar,
	MDBNavbarBrand as NavbarBrand,
	MDBNavbarNav as NavbarNav,
	MDBNavItem as NavItem,
	MDBNavLink as NavLink,
	MDBNavbarToggler as NavbarToggler,
	MDBCollapse as Collapse,
	MDBContainer as Container,
	MDBIcon as Icon,
	MDBSideNavNav as SideNavNav,
	MDBSideNav as SideNav,
	MDBSideNavLink as SideNavLink
} from 'mdbreact';

const Header = () => {
	const [isOpen, setIsOpen] = useState(false);
	const [activeLink, setActiveLink] = useState({
		home: window.location.pathname === '/home',
		about: window.location.pathname === '/about',
		products: window.location.pathname === '/products',
		contact: window.location.pathname === '/contact'
	});
	useEffect(() => {
		document.querySelector('nav').style.height = '65px';
		return () => {
			document.querySelector('nav').style.height = 'auto';
		};
	});
	const handleClick = (id) => () => {
		setIsOpen(false);
		scroll.scrollTo(document.getElementById(id).offsetTop - 100);
		let aL = {};
		Object.keys(activeLink).forEach((key) => {
			if (id === key) aL[key] = true;
			else aL[key] = false;
		});
		setActiveLink(aL);
	};

	const handleToggle = () => {
		setIsOpen(!isOpen);
	};

	return (
		<>
			<Router>
				<div style={{ zIndex: '999' }}>
					<Navbar
						color='elegant-color'
						dark
						expand='md'
						fixed='top'
						scrolling
						transparent>
						<Container>
							<NavbarBrand>
								<img src='MQM LOGO.png' height='25' alt='' />
							</NavbarBrand>
							<NavbarToggler onClick={handleToggle} />
							<Collapse isOpen={false} navbar>
								<NavbarNav right className='mt-1'>
									<NavItem active={activeLink.home}>
										<NavLink
											to='/home'
											onClick={handleClick('home')}
											className='rounded'>
											Home
										</NavLink>
									</NavItem>
									<NavItem active={activeLink.about}>
										<NavLink
											to='/about'
											onClick={handleClick('about')}
											className='rounded'>
											About us
										</NavLink>
									</NavItem>
									<NavItem active={activeLink.products}>
										<NavLink
											to='/products'
											onClick={handleClick('products')}
											className='rounded'>
											Products
										</NavLink>
									</NavItem>
									<NavItem active={activeLink.contact}>
										<NavLink
											to='/contact'
											onClick={handleClick('contact')}
											className='rounded'>
											Contact
										</NavLink>
									</NavItem>
								</NavbarNav>
							</Collapse>
						</Container>
					</Navbar>
					<SideNav
						logo='MQM LOGO.png'
						hidden
						bg='market.jpg'
						mask='rgba-black-strong'
						triggerOpening={isOpen}
						breakWidth={1300}
						className='deep-purple darken-4 pt-4'>
						<li>
							<ul className='social'>
								<li>
									<a href='#!'>
										<Icon fab icon='facebook-f' />
									</a>
								</li>
								<li>
									<a href='#!'>
										<Icon fab icon='instagram' />
									</a>
								</li>
								<li>
									<a href='#!'>
										<Icon fab icon='twitter' />
									</a>
								</li>
							</ul>
						</li>
						<SideNavNav>
							<SideNavLink topLevel to='/home' onClick={handleClick('home')}>
								<Icon far icon='building' />
								Home
							</SideNavLink>
							<SideNavLink topLevel to='/about' onClick={handleClick('about')}>
								<Icon far icon='question-circle' />
								About us
							</SideNavLink>
							<SideNavLink
								topLevel
								to='/products'
								onClick={handleClick('products')}>
								<Icon fab icon='delicious' />
								Products
							</SideNavLink>
							<SideNavLink
								topLevel
								to='/contact'
								onClick={handleClick('contact')}>
								<Icon far icon='address-book' />
								Contact
							</SideNavLink>
						</SideNavNav>
					</SideNav>
				</div>
			</Router>
		</>
	);
};

export default Header;
